export default {
  name: 'marking--docStatusSystem',
};